
export default {
	name: 'payMent',
	data() {
		return {
			// 版本号
			version: "3.8.8",
			endTime: '',
			currentIndex: -1,
			centerDialogVisible: false,
			payTypeList: [],
			payTypeList1: [
				{
					label: '对公打款',
					url: require('./logo.png')
				},
				{
					label: '支付宝支付码',
					url: require('./ali.png')
				},
				{
					label: '微信支付码',
					url: require('./wechat.png')
				},
				
			],
			payTypeList2: [
				{
					label: '对公打款',
					url: require('./logo.png')
				}
				
			],
			companyName: '云时空',
			logoSrc: "",
			appSrc: "",
			timerId: null,
			pollInterval: 3000, // 轮询间隔5秒
			user: {},
			amount: 1000,
			flag:false
		};
	},
	beforeDestroy() {
		this.stopPolling();
	},
	created() {
		this.stopPolling();
	},
	mounted() {
		this.user = this.$store.state.user;
		this.companyName = this.user.company;
		this.getAmount()
	},
	methods: {
		goback() {
			this.$router.push({
				path: "/user",
			}); 
		},
		// 启动轮询
		startPolling() {
			this.timerId = setInterval(this._renewalState, this.pollInterval);
		},
		_renewalState() {
			let _this = this
			let params = {
				userId: this.user.id,
				companyId: this.user.customerId,
			}
			this.$http.post('/api/renewal/queryState', params ).then((res) => {
				console.log(res);
				if (res.data.data == 2) {
				_this.centerDialogVisible = false;
				_this.$message({
					message: '支付成功',
					type: 'success'
				});
				_this.stopPolling()
				setTimeout(() => {
					_this.$router.push({
						path: "/",
						query:{
							url:'payment'
						}
					}); 
				}, 2000);
			}
			})
		},
		getAmount() {
			let _this = this
			let params = {
				userId: this.user.id,
			}
			this.$http.post('/api/renewal/amount', params).then((res) => { 
				console.log(res);
				this.flag = res.data.success
				if (this.flag == false) {
					this.payTypeList = this.payTypeList2
				} else {
					this.payTypeList = this.payTypeList1
				}
				this.amount = parseInt(res.data.data)
			})
			
		},
		_companyRenewal() {
			let params = {
				userId: this.user.id,
				companyId: this.user.customerId,
				orderTitle: '药智采/' + this.user.company + '/年度续费',
				payType: this.currentIndex == 2 ? 'WX_NATIVE' : 'ALI_QR',
				amount: this.amount, // 支付金额
			}
			var _this = this
			this.$http.post('/api/renewal/payOrder', params).then((res) => {
				console.log(res);
				if (res.data.success == true) {
					_this.appSrc = res.data.data.payData
					_this.startPolling()
				} else {
					_this.$message({
						message: res.message,
						type: 'warning'
					});
				}
			})
		},
		// 停止轮询
		stopPolling() {
			if (this.timerId) {
				clearTimeout(this.timerId);
				this.timerId = null;
			}
		},
		dialogdata() {
            this.$confirm("对公打款后, 请及时与商务代表联系，进行延期。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
              })
              .then(() => {
                
              })
              .catch(() => {});
		},
		payDown() {
			var _this = this;
			if (this.currentIndex == 0) {
				this.dialogdata()
				return
			}
			if (this.currentIndex < 1) {
				this.$message({
					message: '请选择微信或支付宝支付方式',
					type: 'warning'
				});
				return
			} else {
				if (_this.amount == '' || _this.amount == null || _this.amount == 0) {
					_this.$message({
						message: '支付金额不正确',
						type: 'warning'
					});
					return
				} else {
					_this.centerDialogVisible = true;
					_this._companyRenewal()
				}

			}
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
					this.stopPolling()
				})
				.catch(_ => { });
		},
		changeItem(index) {
			this.currentIndex = index;
		},

		queryYear() {
			var date = new Date();
			var year = date.getFullYear();  // 年份
			var month = date.getMonth() + 1;  // 月份，返回值为0-11，所以需要加1
			var day = date.getDate();  // 日期
			// 对月份和日期进行补零
			month = month < 10 ? '0' + month : month.toString();
			day = day < 10 ? '0' + day : day.toString();
			var currentDate = year + '-' + month + '-' + day;
			return currentDate
		},
		submit(form) {
			var _this = this
			this.$refs[form].validate((valid) => {
				if (valid) {
					this.$http.post('/api/user/register', this.form).then((res) => {
						if (res.data.success) {
							this.$message({
								message: res.data.message,
								type: 'success'
							})
							this.$store.commit('register', this.form)
							window.setTimeout(() => {
								this.$router.push({
									name: 'register1',
									params: {
										type: _this.form.type
									}
								})
							}, 1500)
						} else {
							this.$message.error(res.data.message)
						}
					})
				} else {
					return false
				}
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/user/payMent/index.js